import { render, staticRenderFns } from "./login.vue?vue&type=template&id=9d850688&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "../asset/css/login.scss?vue&type=style&index=0&id=9d850688&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d850688",
  null
  
)

export default component.exports